import styled from 'styled-components'

export const Wrapper = styled.div`
  padding: 24px;
  background: #f0f2f5;
  min-height: 100vh;
`

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  h2 {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
  }
`

export const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`

export const BulkActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`

export const TableWrapper = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02);

  .ant-table-wrapper {
    .ant-table {
      font-size: 14px;
    }

    .ant-table-thead > tr > th {
      background: #fafafa;
      font-weight: 600;
    }

    .ant-table-tbody > tr > td {
      padding: 12px 16px;
    }

    .ant-table-expand-icon-cell {
      padding: 12px 8px 12px 16px !important;
    }

    .ant-table-row-expand-icon {
      color: #1890ff;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        color: #40a9ff;
      }
    }
  }
`
